import React from 'react'
import { View } from 'components/View.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import canEditByIdWorkoutSelector from 'modules/workout/redux/selectors/can-edit-by-id/index.js'
import WorkoutEditNotes from 'pages/Workout/components/Workout/components/EditNotes/index.js'
import WorkoutNotesText from 'pages/Workout/components/Workout/components/NotesText/index.js'

export default function WorkoutNotes ({ id }) {
  const canEdit = useSelector(canEditByIdWorkoutSelector(id))
  let element

  if (canEdit) {
    element = <WorkoutEditNotes id={id} />
  } else {
    element = <WorkoutNotesText id={id} />
  }

  return (
    <View my>
      {element}
    </View>
  )
}
